import { CoreModelCode, coreModelColorMap, coreModelSignalMap } from '@3fourteen/core';
import { useCrude } from 'hooks/useCrude';
import { memo, useMemo } from 'react';

import { CoreModelCard } from 'components';
import { CardProps } from 'components/Card/component';
import { routes } from 'services/routes';

interface CrudeCardProps {
  cardId: CardProps['cardId'];
}

function CrudeCard({ cardId }: CrudeCardProps) {
  const { crude } = useCrude();

  const coreReadings = useMemo(() => {
    return crude?.readings.map(({ component, signal }) => {
      const color = coreModelColorMap[signal];
      return {
        color,
        component,
        reading: coreModelSignalMap[CoreModelCode.crude][signal],
      };
    });
  }, [crude]);

  return (
    <CoreModelCard
      cardId={cardId}
      readings={coreReadings ?? []}
      title='Crude'
      date={crude?.date ?? ''}
      href={routes.models.crude}
    />
  );
}

export default memo(CrudeCard);
